import { ImageViewerModal } from './ImageViewerModal';

export default ImageViewerModal;
